<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive" :key="$router.currentRoute.fullPath"></router-view> -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>

<style lang="scss">
#app {
  background: #F1F5F7;
}

/* global-styles.css */
.password-field {
  // width: 100%;
  position: relative;
  display: flex;

  input {
    flex: 1;
  }

  .password-toggle {
    position: absolute;
    right: 10px;
    /* 调整位置以适应你的设计 */
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: inline-block;
  }

  .password-toggle::before,
  .password-toggle::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .password-toggle::before {
    background: url('./assets/image/1.svg') no-repeat center center;
    background-size: contain;
  }

  .password-visible.password-toggle::before {
    background: url('./assets/image/1.svg') no-repeat center center;
    background-size: contain;
  }

  .password-hidden.password-toggle::before {
    background: url('./assets/image/2.svg') no-repeat center center;
    background-size: contain;
  }
}

/* 当按钮被按下时的样式 */
.ds-button-large:hover,
.ds-button-large:active {
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2) !important;
  background: #c0000a !important;
  transform: translateY(1px);
}

.ds-button:hover,
.ds-button:active {
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2) !important;
  background: #c0000a !important;
  transform: translateY(1px);
}

.button:hover,
.button:active {
  /* 按下时更暗更深的阴影 */
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2);
  background: #f8f8f8 !important;
  transform: translateY(1px);
  /* 向下稍微移动一点，模拟按下的视觉效果 */
}

.cup {
  cursor: pointer;
}

.disf {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
